import React, { Component } from 'react';
import { Container, Row, Col, Image, Dropdown, Form, Button } from 'react-bootstrap';
import { Spinner } from 'react-activity';
import { store } from 'react-notifications-component';

import { get_order, get_image } from './api.js'

import Pending from './components/pending'
import Complete from './components/complete'
import Waiting from './components/waiting'
import lang_en from "../../translate/en";
import lang_es from "../../translate/es";

import Logo from './assets/logo.png';

import './index.css'

let intervalTimmer, intervalOrder

class Checkout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      coin:'',
      cart:{
        products:[],
        total:''
      },
      coins:[],
      shipping:[],
      reference_order:'3asfgt23t2',
      total:'1231',
      minutes:'--',
      seconds:'--',
      lang:"es",
      translations:{},
      waiting:false
    }
  }

  componentDidMount(){
    let { search } = window.location
    if(search)
      if(search.indexOf('?token=') != -1){
        this.getData()
      }
  }

  async getData(){
    const self = this;
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    const email = params.get('email') || ''
    let imagePromise = get_image(token)
    this.setState({...await imagePromise, email})
    self.getOrder(token)
    intervalOrder = setInterval(()=>self.getOrder(token), 1000 * 60);
  }

  async getOrder(token){
    try {
      let orderPromise = get_order(token)
      let order = await orderPromise;
      if (order.lang == 'es'){
        order.translations = lang_es;
      } else if (order.lang == 'en'){
        order.translations = lang_en;
      }
      this.setState({...order},() => this.checkStatus())
    } catch (e) {
      console.log(e);
    }
  }

  checkStatus(){
    if(this.state.status == 'pending') this.setCounter()
  }

  setCounter(){
    let self = this;
    intervalTimmer = setInterval(function () {
      let date = new Date();
      let expiration = (self.state.expiration)? new Date(self.state.expiration * 1000) :0;
      let distance = expiration - date
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if(distance < 0){
        self.setState({status:'cancelled', token:''},()=>{
          clearInterval(intervalTimmer)
        })
      }
      self.setState({minutes,seconds})
    }, 1000);
  }

  addNotification(){
    store.addNotification({
      title: "Copied!",
      message: 'Text has been copied to clipboard',
      type: "success",
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: 1800,
        onScreen: true
      }
    });
  }


  changeStatus(waiting){
    //this.setState({status})
    this.setState({waiting})
    clearInterval(intervalOrder)
  }

  statusSwitch(){
    if (this.state.waiting) return <Waiting {...this.state} changeStatus={this.changeStatus.bind(this)}/>
    switch (this.state.status) {
      case 'pending':
        return <Pending {...this.state} changeStatus={this.changeStatus.bind(this)}/>
        break;
      case 'incomplete':
        return <Pending {...this.state} changeStatus={this.changeStatus.bind(this)}/>
        break;
      case 'completed':
        return <Complete {...this.state}/>
        break;
      case 'cancelled':
        return(
            <div style={{textAlign:'center',height:'calc(100vh - 110px)', paddingTop:'calc(50vh - 100px)'}}>
              <div>
                Operation Expired
              </div>
            </div>
          )
        break;
      default:
        return(
          <div style={{textAlign:'center', paddingTop:'calc(50vh - 150px)'}}>
            <Spinner size={70} color={"#1F45FF"} animating={true} style={{margin:'auto'}}/>
          </div>
        )

    }
  }

  render() {
    return(
        <div>
          <div className="contenedor-wallets-generals" style={{ paddingLeft: 10, paddingRight: 10, marginTop:10 }}>
            <div className='checkout-contianer'>
              <Image src={Logo} style={{marginBottom:30,marginTop:20, height:50, marginLeft:-13}}/>
              {this.statusSwitch()}
            </div>

          </div>
        </div>
    )
  }
} export default Checkout;
